import { createFileRoute, useRouteContext } from "@tanstack/react-router";

import { useBookingsByEventQuery } from "@/features/event/hooks/use-events-query";

import { EventAttendee } from "../-components/event-attendee";

export const Route = createFileRoute("/_auth/org/$orgId/event/$eventId/attendees/")({
  component: Page
});

function Page() {
  const { event } = useRouteContext({
    from: "/_auth/org/$orgId/event/$eventId/attendees/"
  });

  const { data: bookings = [], isLoading, isFetching } = useBookingsByEventQuery(event.id);

  return (
    <div className="py-4 md:py-6">
      <EventAttendee event={event} bookings={bookings} isLoading={isLoading || isFetching} />
    </div>
  );
}
